module.exports = __webpack_public_path__ + "static/media/home-bg-2.c88a09c7.png";